import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { formatText } from '../../common/TextFormatterProvider';

function DataBreadcrumb({ tableName, profileName, groupBy, onManageFilesClick }) {
  return (
    <Box sx={{ 
      p: 2, 
      borderBottom: '1px solid rgba(255, 255, 255, 0.03)',
      backgroundColor: 'background.paper'
    }}>
      <Breadcrumbs 
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Typography color="text.primary">Data</Typography>
        {tableName && (
          <Typography color="text.primary">{formatText(tableName)}</Typography>
        )}
        <Link
          color="text.primary"
          component="button"
          variant="body1"
          onClick={onManageFilesClick}
          sx={{
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
              cursor: 'pointer'
            }
          }}
        >
          Manage Files
        </Link>
        <Typography color="primary">
          {profileName || 'Home'}
        </Typography>
      </Breadcrumbs>
    </Box>
  );
}

export default DataBreadcrumb;